import React, { useEffect, useState, useCallback } from 'react';
import BillingProcess from './BillingProcess';
import { Card } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsRotate } from '@fortawesome/pro-solid-svg-icons';
import ProgressBar from 'shared/components/ProgressBar';
import sctheme from 'app/styles/sctheme';
import { useSelector } from 'react-redux';

const Progress = props => {
  const {
    currentProcess,
    successfullyGeneratedInvoiceCount,
    successfullyFinalizedCount,
    queuedToAbortInvoiceCount,
    totalInvoiceCount
  } = props;

  const timestamp = useSelector(state => state.invoices.invoicingTimestamp);

  const [variables, setVariables] = useState({ a: null, b: null });

  const getProcessVariables = useCallback(() => {
    switch (currentProcess) {
      case BillingProcess.GeneratingInvoices:
        return { a: successfullyGeneratedInvoiceCount, b: totalInvoiceCount };
      case BillingProcess.FinalizingInvoices:
        return { a: successfullyFinalizedCount, b: totalInvoiceCount };
      case BillingProcess.AbortingInvoices:
        return { a: totalInvoiceCount - queuedToAbortInvoiceCount, b: totalInvoiceCount };
      default:
        return { a: null, b: null };
    }
  }, [
    currentProcess,
    successfullyGeneratedInvoiceCount,
    totalInvoiceCount,
    successfullyFinalizedCount,
    queuedToAbortInvoiceCount
  ]);

  useEffect(() => {
    const { a, b } = getProcessVariables();
    setVariables({ a, b });
  }, [getProcessVariables]);

  const process =
    currentProcess === BillingProcess.AbortingInvoices
      ? 'Deleting Invoices'
      : currentProcess === BillingProcess.GeneratingInvoices
      ? 'Generating Invoices'
      : 'Finalizing Invoices';

  const progress = variables.a && variables.a !== 0 ? (variables.a / variables.b) * 100 : 0;

  return (
    <Card style={{ padding: '40px', marginTop: '40px' }}>
      <div className="d-flex align-items-center" style={{ fontSize: '20px', marginBottom: '2rem' }}>
        <FontAwesomeIcon
          icon={faArrowsRotate}
          style={{ color: sctheme.blues.primary, animation: 'fa-spin 3s infinite linear' }}
        />
        <p className="font-weight-bold mb-0 ml-2" style={{ color: sctheme.grays.$800 }}>
          {process}
        </p>
      </div>
      <div className="mb-3 font-weight-bold" style={{ color: sctheme.grays.$900 }}>
        {variables.a} of {variables.b} invoices complete
      </div>
      <ProgressBar height="32px" progress={progress} />
      <div className="mt-3" style={{ color: sctheme.grays.$700 }}>
        As of {timestamp}
      </div>
    </Card>
  );
};

export default Progress;
